import { Component } from 'opus-angular-seed-core';
import template from './template.html';

/**
 * The chapter list of the selected language: chapters and sections, ordered by drag and drop.
 */
@Component({
    bindings: {
        list: '<',
        selected: '<',
        isEditing: '<',
        isSourceLanguage: '<',
        translationLabel: '<',
        getStateLabel: '&',
        onSelect: '&',
        onMoved: '&',
        onToggleMenu: '&',
        onStartEdit: '&',
        onFinishEdit: '&',
        onToggleVisibility: '&',
        onSetVisibilityInAllLanguages: '&',
        onExport: '&',
        onDelete: '&',
        onTranslate: '&',
        onDeleteSection: '&',
        onAddChapterToSection: '&',
        onSetSectionChaptersVisibility: '&',
        onAddChapter: '&',
        onAddSection: '&'
    },
    template
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/authoringTool/editor/toc/index.js